import { SET_ACTIVE_ART_WALL_BACKGROUND } from './../const';

export default (activeArtWallBackground) => {
  return {
    type: SET_ACTIVE_ART_WALL_BACKGROUND,
    activeArtWallBackground: activeArtWallBackground
  }
};
